exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#iconStyleUploader .v-chip .v-avatar{height:48px!important;min-width:48px;width:48px!important}#iconStyleUploader .v-chip .v-chip__content{height:48px}#iconStyleUploader .v-chip .v-avatar img{height:30px;width:30px;border-radius:0;margin-right:-10px}#iconStyleUploader .verte__controller{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6f3fa12","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/settings/modals/IconStyleUploader.vue
// module id = 1981
// module chunks = 0